import {BrowserModule} from '@angular/platform-browser';
import {NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from "@angular/common/http";
import {TokenInterceptor} from "./services/interceptor";
import {kanAuthService} from "./services/auth";
import {kanDogsService} from "./services/dogs";
import {kanUsersService} from "./services/users";
import {UIRouterModule} from "@uirouter/angular";
import {kanMembershipService} from "./services/membership";
import {kanServicesService} from "./services/services";
import {kanNotesService} from "./services/notes";
import {kanFilesService} from "./services/files";
import {kanPartnersService} from "./services/partners";
import {kanMailsService} from "./services/mails";
import {kanMailTemplatesService} from "./services/templates";
import {kanTermsService} from "./services/terms";
import {kanContractsService} from "./services/contracts";
import {kanContract} from "./components/contract/component";
import {MatButtonModule, MatIconModule, MatProgressSpinnerModule} from "@angular/material";
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {kanLoadingService} from "./services/loading";
import {kanLoading} from "./components/loading/component";

@NgModule({
    declarations: [
        kanContract,
        kanLoading
    ],
    imports: [
        BrowserModule,
        HttpClientModule,
        UIRouterModule,
        FormsModule,
        TranslateModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule
    ],
    entryComponents: [
        kanContract,
        kanLoading
    ],
    exports: [
        kanContract,
        kanLoading
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: TokenInterceptor,
            multi: true
        },
        kanAuthService,
        kanUsersService,
        kanDogsService,
        kanPartnersService,
        kanMembershipService,
        kanServicesService,
        kanNotesService,
        kanFilesService,
        kanMailsService,
        kanMailTemplatesService,
        kanTermsService,
        kanContractsService,
        kanLoadingService
    ],
    bootstrap: []
})
export class kanServiceModule {
}



// WEBPACK FOOTER //
// ./src/modules/services/module.ts